import { Button, Snackbar, SnackbarProps } from "@mui/material";
import {
  PWA_UPDATE_ACTION_LABEL,
  PWA_UPDATE_DISMISS_LABEL,
  PWA_UPDATE_MESSAGE,
  PWA_UPDATE_SNACKBAR_ORIGIN,
} from "../pwa-constant";

export interface UpdateAvailableSnackbarProps {
  open: boolean;
  onReload: () => void;
  onDismiss: () => void;
  sx?: SnackbarProps["sx"];
}

const UpdateAvailableSnackbar = ({
  open,
  onReload,
  onDismiss,
  sx,
}: UpdateAvailableSnackbarProps) => (
  <Snackbar
    open={open}
    anchorOrigin={PWA_UPDATE_SNACKBAR_ORIGIN}
    message={PWA_UPDATE_MESSAGE}
    sx={sx}
    action={
      <>
        <Button color="inherit" size="small" onClick={onDismiss}>
          {PWA_UPDATE_DISMISS_LABEL}
        </Button>
        <Button
          color="primary"
          size="small"
          variant="contained"
          onClick={onReload}
        >
          {PWA_UPDATE_ACTION_LABEL}
        </Button>
      </>
    }
  />
);

export default UpdateAvailableSnackbar;
